import { gql, TypedDocumentNode } from '@apollo/client'

import { CustomerAddressFragment } from './CustomerAddressFragment.generated'

export const customerAddressFragment = gql`
  fragment CustomerAddressFragment on CustomerAddress {
    id
    firstname
    lastname
    street
    postcode
    city
    telephone
    countryCode
    company
    vatId
    defaultShipping
    defaultBilling

    region {
      regionId
      region
      regionCode
    }
  }
` as TypedDocumentNode<CustomerAddressFragment, never>
